import { DIALOG_TYPES } from './dialog-types.model';

export class DialogScheduleModel {
  type: DIALOG_TYPES = null;
  headerText: string = null;
  subHeaderText: string = null;
  errorText: string = null;
  subInfoText: string = null;
  buttonCancelText: string = null;
  buttonConfirmText: string = null;
  selectedSchedule: any;
}
